import React, { Dispatch } from 'react';
import Translator from '../../../../core/i18n';
import { Log } from 'ng2-logger';
import Moment from 'moment';
import ProcessingActivity from '../activity-proccessing/processing-activity';
import { Common } from '../../../../core/common';
import { ISignleActivityCard } from '../../../../models/components/single-activity-card';
import { UserType } from '../../../../models/pages/login.d';
import { connect } from 'react-redux';
import { IAppState, IAction } from '../../../../models/action/core';
import CVideoQuestion from './question';
import { IVideoQuestionChoices, IVideoFlowPlayerQuestionChoices, IVideoFlowPlayerQuestions } from '../../../../models/components/video-questions';
import { VideoQuestionType } from '../../../../models/enums/VideoQuestionType';
import { enrollmentStatus } from '../../../../models/enums/enrollmentStatus';
import ProgressCircle from '../../../progress-circle/progress-circle';
import { SecurityContextType, SecurityPermissionType } from '../../../../core/SecurityContext';
import { getCourseContentsWeekActivitiesAction, SetUpdateInput, getCourseContentsActivityCardAction } from '../../../../store/actions/coursePage';
import EdiText from 'react-editext';
import FlowPlayerTs from '../../../../core/flow-player';
import { Guid } from 'guid-typescript';
import { CoursePageService } from '../../../../api/course-page-service';
import ProgressCircleStudent from '../../../progress-circle/progress-circle-student';
import { setRefreshMyEnrollments, enrollmentGetAction, enrollmentAddActionLog } from '../../../../store/actions/enrollment';
import { ActivityCompletionType } from '../../../../models/enums/activityCompletionType';
import { GetActivitiesType } from '../../../../models/enums/GetActivityType';
import { CourseContentMenuType } from '../../../../models/enums/CourseContentMenuType';
import Tooltip from '../../../tooltip/main';
import VideoBar from '../../../video-bar/main';

const T = Translator.create();
let _common: Common;
const _logger = Log.create('VideoMain.tsx');
const maxEditTextLength = 65;
let getActivityId: string;
let index: number = 0;

let guid: string;
const coursePageService = new CoursePageService();

class VideoActivityCard extends React.Component<ISignleActivityCard> {
    public state = {
        editTextValue:
            this.props.activityCard!.name!.toString().length > maxEditTextLength
                ? this.props.activityCard!.name!.slice(0, maxEditTextLength).toString() + '...'
                : this.props.activityCard!.name!.toString(),
        editTextHandleValue: this.props.activityCard!.name!.toString()
    };
    constructor(props: any) {
        super(props);
        _common = new Common();
        Moment.locale(T.i18next.language);
        getActivityId = this.props.activityCard!.activityId!;
        guid = Guid.create().toString();
        this.afterSave = this.afterSave.bind(this);
    }

    public setAnswer = (choice: IVideoQuestionChoices[] | null): string[] => {
        const answer: string[] = [];
        if (choice && choice.length > 0) {
            choice.forEach((x, i) => {
                if (x.isAnswer) {
                    answer.push('' + i + '');
                }
            });
        }
        return answer;
    }
    public setChoice = (choice: IVideoQuestionChoices[]): IVideoFlowPlayerQuestionChoices[] => {
        const newChoice: IVideoFlowPlayerQuestionChoices[] = [];
        if (choice && choice.length > 0) {
            choice.forEach(c => {
                newChoice.push({ ChoiceId: c.testChoiceId, ChoiceText: c.choiceText, Feedback: c.feedBack });
            });
        }
        return newChoice;
    }

    public getQuestions = (): any[] => {
        const returnValue: IVideoFlowPlayerQuestions[] = [];
        if (this.props.activityCard!.videoQuestions) {
            this.props.activityCard!.videoQuestions.forEach(x => {
                returnValue.push({
                    ShowOnSecond: x.showOnSecond,
                    QuestionType: VideoQuestionType[x.questionType],
                    Question: x.question,
                    ID: x.questionId,
                    GoBackTo: x.goBackTo,
                    ContinueEvenWrong: x.continueEvenWrong,
                    Choices: this.setChoice(x.videoTestChoices),
                    Answer: this.setAnswer(x.videoTestChoices)
                });
            });
        }
        return returnValue;
    }

    public parseVideoUrlExtension(url: string) {
        if (url.includes('youtube')) {
            return 'youtube';
        } else if (url.includes('vimeo')) {
            return 'vimeo';
        } else if (url.includes('dailymotion')) {
            return 'dailymotion';
        } else {
            return null;
        }
    }

    returnActivityFile = (props: ISignleActivityCard) => {
        let activityFile = null;
        if (props.activityCard!.file && props.activityCard!.file.length > 0) {
            activityFile = props.activityCard!.file[0];
        }
        return activityFile;
    }

    returnEnrollmentId = (props: ISignleActivityCard) => {
        let enrollmentId = props.activityCard!.enrollmentId ?? '';
        if (props.activityCard!.videoInformation && props.activityCard!.fileEmbed && props.activityCard!.fileEmbed.includes("youtube")) {
            if (props.activityCard!.videoInformation.enrollmentId) {
                enrollmentId = props.activityCard!.videoInformation.enrollmentId;
            }
        }
        return enrollmentId;
    }

    public setupFlowPlayer(props: ISignleActivityCard, result?: any) {
        let viewData = (props.activityCard!.videoInformation && props.activityCard!.videoInformation.viewData) ? props.activityCard!.videoInformation.viewData : '';
        const playerName = 'player_' + props.activityCard!.activityId;
        const activityFile = this.returnActivityFile(props);
        const activityCardFilePath = activityFile ? activityFile.filePath : ''
        const videoUrl = (props.activityCard!.fileEmbed) ? props.activityCard!.fileEmbed : activityCardFilePath;
        let extension = null;
        if (result) {
            extension = (activityFile?.extension) ? activityFile?.extension.replace('.', '') : '';
        } else {
            extension = this.parseVideoUrlExtension(videoUrl);
        }

        viewData = _common.ConvertVideoTestLogViewData(viewData);

        const enrollmentIdParam = this.returnEnrollmentId(props);

        let activityId = props.activityCard!.activityId;

        let splitted = props.activityCard!.activityId?.split("_") ?? null;

        if (splitted) {
            activityId = splitted[0];
        }
        
        const flowPlayer = new FlowPlayerTs(
            this.props,
            {
                autoPlay: 0,
                report: window.appSettings.API_URL + '/api/video/savetracking?activityId=' + activityId + '&enrollmentId=' + enrollmentIdParam + '&classId=' + props.classId,
                savepath: '/Video/SaveInteraction?InteractionData=@Request.Form&id=@onlyVideoRefId',
                json: '/Video/ManageInteraction?id=@onlyVideoRefId&attemptId=@Model.EnrollmentAttempId',
                player: playerName,
                disableSeek: 0,
                editmode: false,
                isFirst: 1,
                question: 'question_' + props.activityCard!.activityId,
                videoParameters: {
                    correct: T.t('r_video_correctanswer'),
                    wrong: T.t('r_video_wronganswer'),
                    noselect: T.t('r_video_warning_answerrequired'),
                    cantfind: T.t('r_video_questionnotfound'),
                    required: T.t('r_video_warning_fieldrequired'),
                    noquestions: T.t('r_video_noquestionsyet'),
                    Extension: extension,
                    Interactions: this.getQuestions(),
                    Meta: {
                        Category: null,
                        Duration: props.activityCard!.duration,
                        Instructor: null,
                        UploadDate: null,
                        VideoName: this.props.activityCard!.name,
                        VideoURL: result ?? videoUrl
                    }
                },

                language: T,
                isStudent: (props.userType && props.userType === UserType.Student) ? 1 : 0,
                courseId: props.coursePageActivityId,
                seekTime: _common.getSeekTime(viewData.toString()),
                tracktime: 10,
                Tracking: {
                    TotalPartSec: 0,
                    ViewLog: [],
                    ViewParts: [],
                    viewData: viewData.toString()
                },
                updateDataFunction: (param: any) => { this.props.dispatch(setRefreshMyEnrollments(param)) }
            });

        flowPlayer.BuildVideo();
    }

    public onFirstLoad = (props: ISignleActivityCard) => {
        if (props.activityCard!.file && props.activityCard!.file.length > 0) {
            // tslint:disable-next-line
            fetch(props.activityCard!.file[0].filePath, {
                headers: {
                    'Authorization': 'Bearer ' + _common.GetAuthLocalStorage().access_token,
                    'Access-Control-Allow-Origin': '*'
                },

            }).then((response: any) => {
                if (response.status === 200) {
                    return response.text();
                }
            }).then((result) => {
                this.setupFlowPlayer(props, result);
            });
        } else if (props.activityCard!.fileEmbed) {
            this.setupFlowPlayer(props);
        }
    }

    public componentDidMount() {
        this.onFirstLoad(this.props);
        if (!window.isYoutubeApiReady) {
            window.onYouTubeIframeAPIReady = (e: any) => {
                window.isYoutubeApiReady = true;
            };
        }
    }

    afterSave() {
        this.props.dispatch(getCourseContentsWeekActivitiesAction(
            this.props.coursePageClassId ? this.props.coursePageClassId : '0',
            this.props.coursePageActivityId ? this.props.coursePageActivityId : '0',
            this.props.weekOrUnitId !== '0',
            0,
            1000,
            this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId!,
            false,
            false,
            null,
            'contentWeekActivities',
            'get', undefined, this.props.sortKey ?? "-"));
    }

    public handleSave = (name: any) => {
        if (this.props.activityCard?.activityId && this.props.activityCard?.name !== name) {
            this.props.dispatch(
                SetUpdateInput(this.props.activityCard.activityId, name, 'api/activity/updateActivityName', 'POST', this.props.classId!, this.afterSave)
            );
            this.setState({
                editTextValue: name.length > maxEditTextLength
                    ? name.slice(0, maxEditTextLength).toString() + '...'
                    : name.toString(), editTextHandleValue: name
            });
        }
    };

    public handleClick(value: string) {
        this.setState({ editTextValue: value });
    };

    checkPrerequisite = () => {
        let isPrerequisiteCompleted = false
        if (this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student) {
            if (this.props.enrollmentData) {
                let prerequisiteActivities = this.props.enrollmentData.filter(f => f.activityId === this.props.activityCard!.prerequisiteActivityId)
                if (prerequisiteActivities.length > 0) {
                    if (prerequisiteActivities[0].status === enrollmentStatus.Completed && this.props.userType === UserType.Student) {
                        isPrerequisiteCompleted = true;

                    }
                }

            }
        }
        return isPrerequisiteCompleted;
    }

    onClickRefresh = () => {
        let getActivitiesType: GetActivitiesType;
        if (this.props.courseContentMenuType === CourseContentMenuType.week || this.props.courseContentMenuType === CourseContentMenuType.weekAndActivityStory) {
            getActivitiesType = GetActivitiesType.Week;
        } else if (this.props.courseContentMenuType === CourseContentMenuType.weekAndActivity) {
            getActivitiesType = GetActivitiesType.Activity;
        } else {
            getActivitiesType = GetActivitiesType.Course;
        }

        if (this.props.classes?.classes?.length <= 0) {
            getActivitiesType = GetActivitiesType.Course;
        }

        coursePageService.RequestClearCourseCacheData({ ClassId: this.props.coursePageClassId ? this.props.coursePageClassId : '0', CourseId: this.props.coursePageActivityId ? this.props.coursePageActivityId : '0' }).then(
            this.props.dispatch(enrollmentGetAction(this.props.coursePageClassId ? this.props.coursePageClassId : '0', this.props.activityCard!.activityId ?? '0'))
        ).then(this.props.dispatch(getCourseContentsActivityCardAction(
            getActivitiesType,
            this.props.coursePageClassId ?? "0",
            this.props.coursePageActivityId!,
            this.props.activityCard?.activityId ?? "0",
            "-1",
            1,
            0,
            "updateOneActivity",
            "get",
            "",
            false
        )));

    };

    public clickToDownload = async (e: any) => {
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();
        if (filepath && fileName) {
            await _common.DownloadLink(filepath + '/download', fileName);

            this.props.dispatch(
                enrollmentAddActionLog({
                    ActivityCompletionType: ActivityCompletionType.DownloadAttachment,
                    ActivityId: this.props.activityCard!.activityId!,
                    EnrollmentId: this.props.activityCard!.enrollmentId!,
                    ClassId: this.props.classId
                })
            );
        }

    };


    renderCardHeader = () => {

        let enrollmentData = this.props.enrollmentData!.filter(enr => enr.activityId === this.props.activityCard!.activityId);
        let enrollmentDataStatus = enrollmentData.length > 0 ? enrollmentData[0].status : enrollmentStatus.NotStarted
        let activityEnrollmentStatus = this.props.activityCard!.enrollmentStatus ? this.props.activityCard!.enrollmentStatus
            : enrollmentDataStatus;

        let activityDeadline = this.props.activityCard!.taskDeadLine ? this.props.activityCard!.taskDeadLine : null;

        return (
            <div className="card-header">
                <div className={"activity-title " + (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? 'arabic-text-card' : '')}>
                    <img
                        src={_common.GetActivityTypeIcons('video')}
                        alt="Video Activity Icon"
                    />
                    {
                        Common.HasPermission(SecurityContextType.Class, SecurityPermissionType.Activity_Add, this.props.classId!) ? (
                            <div title={this.props.activityCard!.name} className="visible">
                                <EdiText
                                    type="text"
                                    onSave={this.handleSave}
                                    onCancel={event => this.handleClick(this.state.editTextValue.length > maxEditTextLength
                                        ? this.state.editTextValue.slice(0, maxEditTextLength).toString() + '...'
                                        : this.state.editTextValue.toString())}
                                    onEditingStart={event => this.handleClick(this.state.editTextHandleValue)}
                                    value={this.state.editTextValue}
                                    showButtonsOnHover={true}
                                    saveButtonClassName="hideEditextSaveButton"
                                    cancelButtonClassName="hideEditextCancelButton"
                                    validationMessage={T.t('r_forum_tree_character')}
                                    // tslint:disable-next-line:jsx-no-lambda
                                    validation={val => val.trim().length >= 3}
                                    editOnViewClick={true}
                                    submitOnEnter={true}
                                    cancelOnEscape={true}
                                    className={'font-weight-bold mobile-activity-title web-activity-title' + (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}
                                    tabIndex={0}
                                />
                            </div>
                        ) : <div title={this.props.activityCard!.name} className={"visible mobile-activity-title web-activity-title" + (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')} tabIndex={0} style={{ cursor: 'pointer', lineHeight: 1.3, whiteSpace: 'pre-line', textOverflow: 'ellipsis' }}>{this.props.activityCard!.name}</div>
                    }

                    <ProcessingActivity
                        externalCssClassName="ml-auto show_on_mobile"
                        activityId={this.props.activityCard!.activityId}
                        activityType={this.props.activityCard!.activityType}
                    />


                </div>

                <div className="activity-status">
                    {/* <h6 style={{ margin: 'auto' }}>{this.props.activityCard?.alwaysOnTop ? '📍' : ''}</h6> */}
                    {this.props.activityCard?.alwaysOnTop ? <span className="pinned"></span> : ''}
                    <span className="badges badges-video activity-type">{T.t('r_activity_type_Video')}</span>

                    {(this.props.activityCard!.allowDownload && this.props.activityCard?.file && this.props.activityCard?.file.length > 0) &&
                        (
                            <div className='pr-1'>
                                <button
                                    className="category-tag-square tag-gray mx-3"
                                    onClick={this.clickToDownload}
                                    data-filename={this.props.activityCard?.file[0]['fileName']}
                                    data-filepath={this.props.activityCard?.file[0]['filePath']}
                                >
                                    <i className="material-icons mr-2">cloud_download</i>
                                    {T.t('r_download')}
                                </button>
                            </div>
                        )}
                    {this.props.activityCard!.taskDeadLine ? <div className="last-date" style={{ paddingRight: '20px' }} data-toggle="tooltip" data-placement="top" title={T.t('r_activity_deadline')}>
                        <Tooltip data={T.t('r_activity_deadline') + ': ' + Moment(this.props.activityCard!.taskDeadLine).format(
                            _common.GetDateFormatFromPrefrences(this.props.userPreferences!, 3)
                        )} position='top' >
                            <span className='word-break-unset'><i className="material-icons mr-1 text-warning">calendar_today</i></span>
                        </Tooltip>
                    </div> : ''}
                    {this.props.userType === UserType.Student ? (
                        <>
                            <button className='alms-btn btn-default btn-icon' onClick={() => this.onClickRefresh()} style={{ minWidth: 'auto' }}>
                                <Tooltip data={T.t('r_activity_update_enrollment')} position='top'>
                                    <img style={{ cursor: 'pointer' }} src={_common.GetDefaultIcons('refresh')} alt="refresh" />
                                </Tooltip>
                            </button>
                            <ProgressCircleStudent enrollmentStatus={activityEnrollmentStatus ?? enrollmentStatus.NotStarted} deadline={activityDeadline} activityCard={this.props.activityCard} />
                        </>
                    ) : (
                        <ProgressCircle activityCard={this.props.activityCard} percent={this.props.activityCard!.completedUser === 0 ? 0 : ((this.props.activityCard!.completedUser! * 100) / this.props.activityCard!.totalEnrollUser!)} />
                    )}
                    &nbsp;
                    <ProcessingActivity
                        externalCssClassName="hide_on_mobile"
                        activityId={this.props.activityCard!.activityId}
                        activityType={this.props.activityCard!.activityType}
                    />
                </div>
            </div>
        )
    }

    renderDescription = () => {
        return (
            (this.props.activityCard?.description && _common.removeHtmlTags(this.props.activityCard!.description).length > 0) ? <><hr className="bottom-border-2" style={{ margin: '0px 3px 0px 3px' }} />
                <div className="row new-activity-padding" style={{ paddingLeft: '3px', paddingBottom: '3px' }}>
                    <div className="col d-flex justify-content-start align-items-baseline new-activity-block" >
                        <img src={_common.GetDefaultIcons('infoicon')} className="mr-2" alt="" />
                        <p className="card-info-text card-info-text-width mobile-activity-description">
                            <b>{T.t('r_add_exam_teacher_note')}</b> <span id='instructor_note' className={(!_common.isArabic(this.props.activityCard!.description, document.body.getAttribute('dir')) ? 'arabic-text-direction' : '')} dangerouslySetInnerHTML={{ __html: this.props.activityCard.description }} />
                        </p>
                    </div>
                </div></> : ''
        )
    }

    renderPrerequisiteBody = (isCompletedPrerequisiteActivity: boolean) => {
        return (
            !isCompletedPrerequisiteActivity && this.props.activityCard?.prerequisiteActivityId && this.props.userType === UserType.Student ?
                <div className='row' style={{
                    opacity: 0.5, flexDirection: 'column',
                    fontSize: '1em !important',

                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                }}>
                    <i className="material-icons" style={{ fontSize: '96px', marginTop: '1rem' }}>lock</i>
                    <h5 className="font-medium">
                        {T.t('r_activity_restriction_by_another_message').replace('{0}', this.props.activityCard?.name).replace('{1}', this.props.activityCard.prerequisiteActivityName)}
                    </h5>
                </div>
                : ''
        )
    }

    returnSubProgress = (progressValue: any) => {
        if (progressValue.length > 4) {
            let subCssProgress = progressValue.substring(0, 4);
            return subCssProgress.indexOf('%') > -1 ? subCssProgress : (subCssProgress + '%')
        }
        else return progressValue
    }

    renderVideoProgress = () => {

        let cssVideoProgressValue = '0';
        let videoDuration = '0';

        if (this.props.userType === UserType.Student) {
            if (this.props.activityCard!.videoInformation) {
                let progress = this.props.activityCard!.enrollmentProgress ?? 0
                if (progress >= 100) {
                    cssVideoProgressValue = '100%';

                }
                else {
                    cssVideoProgressValue = progress.toString() + '%';
                }
                videoDuration = Moment.utc(this.props.activityCard!.videoInformation.seconds * 1000).format('HH:mm:ss');
            }
        }

        return (
            this.props.userType === UserType.Student && 
            <VideoBar videoInformation={this.props.activityCard?.videoInformation} duration={this.props.activityCard?.duration ? this.props.activityCard.duration: 0}></VideoBar>
        )
    }

    public render() {

        let isCompletedPrerequisiteActivity: boolean = this.checkPrerequisite();

        const id = 'player_' + this.props.activityCard!.activityId;
        const addActivityModal = document.getElementById(id);
        if (addActivityModal) {
            setTimeout(() => {
                addActivityModal.classList.remove('is-loading');
            }, 500);
        }

        return (
            (this.props.activityCard) ?
                (
                    <div key={this.props.activityCard.activityId} className="col-12 mobile-padding card-width">
                        <div className={this.props.activityCard.activeStatus === 0 ? 'card new-activity border-pasif' : 'card new-activity'}>
                            {this.renderCardHeader()}
                            <hr className="bottom-border-2 mobile-not-show" />
                            <div className='card-body' style={{ padding: '0px 20px 0px 20px' }}>
                                {this.renderPrerequisiteBody(isCompletedPrerequisiteActivity)}
                                {(!isCompletedPrerequisiteActivity && this.props.activityCard.prerequisiteActivityId && this.props.userType === UserType.Student) ? '' :
                                    <div className="activity-feature-img" >
                                        <div id={'player_' + this.props.activityCard.activityId} style={{ width: '100%', height: '100%', zIndex: 1 }} data-swf="/custom-plugin/flow-player/flowplayer.swf" data-analytics="@analyticsCode"
                                            className="video-wrapper video-display flowplayer aside-time color-light play-button" data-ratio="0.5625" data-embed="false">
                                            <CVideoQuestion activityCard={this.props.activityCard} />
                                        </div>
                                    </div>
                                }
                                {this.renderVideoProgress()}
                                {this.renderDescription()}
                            </div></div>
                    </div>
                ) : (
                    <h4>{T.t('r_activity_was_not_found')}</h4>
                )
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISignleActivityCard): ISignleActivityCard => {
    if (!state) {
        return ownProps;
    }

    const newProps: ISignleActivityCard = Object.assign({}, ownProps, {
        userType: state.login.identitiy.userType,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        userPreferences: state.profile.userPreferences.preferences,
        enrollmentData: state.enrollment.enrollmentData,
        coursePageClassId: state.coursePage.coursePageClassId,
        activityFilters: state.coursePage.activityFilters,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        sortKey: state.coursePage.courseSortingKey,
        classes: state.coursePage.classes
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.coursePage.activityFilters === prev.coursePage.activityFilters &&
        next.coursePage.classes === prev.coursePage.classes &&
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.enrollment.enrollmentData === prev.enrollment.enrollmentData &&
        next.coursePage.weekOrUnitId === prev.coursePage.weekOrUnitId &&
        next.profile.userPreferences.preferences === prev.profile.userPreferences.preferences &&
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.coursePage.activityCard === prev.coursePage.activityCard

    );
    return ret;
};

const CVideoActivityCard = connect(
    mapStateToProps,
    dispatchProps, null, { areStatesEqual }
)(VideoActivityCard);

export default CVideoActivityCard;